<template>
    <div id="homeBox">
        <div class="jqTitle">
            <div>
                <el-button type="primary" :disabled="disabled" size="mini" @click="add">新增</el-button>
                <el-button type="primary" :disabled="disabled||(!isEdit)" size="mini" @click="edit">编辑</el-button>
                <el-button type="success" :disabled="(!disabled)&& isEdit" size="mini" @click="editSave">{{$t('button_save')}}</el-button>
            </div>
        </div>
        <div class="jqBody">

            <el-table ref="table" :data="tableData" style="width: 92%" size="mini" :stripe="true" :height="tableHeight"
                      :header-cell-style="{background:'#eef1f6',color:'black'}"  >
                <el-table-column type="index" label="序号"></el-table-column>
                <el-table-column property="vc_name" label="名称">
                    <template slot-scope="scope">
                        <span v-if="!disabled && scope.row.i_id!==0">{{scope.row.vc_name}}</span>
                        <el-input v-if="scope.row.i_id===0||disabled" v-model="scope.row.vc_name"
                                  placeholder="请输入内容"></el-input>
<!--                        <el-input v-else v-model="scope.row.vc_name" placeholder="请输入内容"></el-input>-->
                    </template>
                </el-table-column>
                <el-table-column property="vc_note" label="标注">
                    <template slot-scope="scope">
                        <span v-if="!disabled && scope.row.i_id!==0">{{scope.row.vc_note}}</span>
                        <el-input v-if="scope.row.i_id===0||disabled" v-model="scope.row.vc_note"
                                  placeholder="请输入内容"></el-input>
<!--                        <el-input v-else v-model="scope.row.vc_note" placeholder="请输入内容"></el-input>-->
                    </template>
                </el-table-column>
                <el-table-column label="约束时间">
                    <template slot-scope="scope">

                    <span v-if="!disabled && scope.row.i_id!==0">{{scope.row.i_range}}</span>
                    <el-input v-if="scope.row.i_id===0||disabled" v-model="scope.row.i_range"
                              placeholder="请输入内容"></el-input>
<!--                    <el-input v-else v-model="scope.row.i_range" placeholder="请输入内容"></el-input>-->
                    </template>
                </el-table-column>
                <el-table-column property="i_flag" label="补贴(交通/午餐)">
                    <template slot-scope="scope">
                        <span v-if="!disabled && scope.row.i_id!==0">{{options1ttt[scope.row.i_flag]}}</span>
                        <el-select v-if="scope.row.i_id===0||disabled" v-model="scope.row.i_flag"
                                   placeholder="请选择">
                            <el-option
                                    v-for="item in options"
                                    :key="item.i_flag"
                                    :label="item.vc_flag"
                                    :value="item.i_flag">
                            </el-option>
                        </el-select>
<!--                        <el-select v-else v-model="scope.row.i_flag" placeholder="请选择">-->
<!--                            <el-option-->
<!--                                    v-for="item in options"-->
<!--                                    :key="item.i_flag"-->
<!--                                    :label="item.vc_flag"-->
<!--                                    :value="item.i_flag">-->
<!--                            </el-option>-->
<!--                        </el-select>-->
                    </template>
                </el-table-column>
                <el-table-column property="i_type" label="假别类型">
                    <template slot-scope="scope">
                       <span v-if="!disabled && scope.row.i_id!==0">{{scope.row.typeTxt}}</span>
                        <el-select v-else v-model="scope.row.i_type"
                                   placeholder="请选择">
                            <el-option
                                    v-for="item in optionstwo"
                                    :key="item.i_id"
                                    :label="item.vc_name"
                                    :value="item.i_id">
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column property="i_edit_type" label="请假方式">
                    <template slot-scope="scope">
                        <span v-if="!disabled && scope.row.i_id!==0">{{scope.row.editTypeTxt}}</span>
                        <el-select v-model="scope.row.i_edit_type" v-else
                                   placeholder="请选择">
                            <el-option
                                    v-for="item in i_edit_typeList"
                                    :key="item.i_id"
                                    :label="item.vc_name"
                                    :value="item.i_id">
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column property="i_edit_type" label="报表显示">
                    <template slot-scope="scope">
                        <span v-if="!disabled && scope.row.i_id!==0">{{i_showtypeListTxt[scope.row.i_showtype]}}</span>
                        <el-select v-model="scope.row.i_showtype" v-else
                                   placeholder="请选择">
                            <el-option
                                    v-for="item in i_showtypeList"
                                    :key="item.i_id"
                                    :label="item.vc_name"
                                    :value="item.i_id">
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column property="i_setup" label="是否包含休息日">
                    <template slot-scope="scope">
                        <span v-if="!disabled && scope.row.i_id!==0">{{scope.row.i_hasrelaxday==0?'否':'是'}}</span>
                        <el-select v-if="scope.row.i_id===0||disabled" v-model="scope.row.i_hasrelaxday"
                                   placeholder="请选择">
                            <el-option
                                    v-for="item in i_hasrelaxdayoptions"
                                    :key="item.i_setup"
                                    :label="item.vc_setup"
                                    :value="item.i_setup">
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column property="i_order" label="显示顺序">
                    <template slot-scope="scope">
                        <span v-if="!disabled && scope.row.i_id!==0">{{scope.row.i_order}}</span>
                        <el-input v-if="scope.row.i_id===0||disabled" v-model="scope.row.i_order"
                                  placeholder="请输入内容"></el-input>
<!--                        <el-input v-else v-model="scope.row.i_order" placeholder="请输入内容"></el-input>-->
                    </template>
                </el-table-column>
                <el-table-column property="i_setup" label="是否启用">
                    <template slot-scope="scope">
                        <span v-if="!disabled && scope.row.i_id!==0">{{(scope.row.i_setup + '')==='-1'?'否':'是'}}</span>
                        <el-select v-if="scope.row.i_id===0||disabled" v-model="scope.row.i_setup"
                                   placeholder="请选择">
                            <el-option
                                    v-for="item in options1"
                                    :key="item.i_setup"
                                    :label="item.vc_setup"
                                    :value="item.i_setup">
                            </el-option>
                        </el-select>
<!--                        <el-select v-else v-model="scope.row.i_setup" placeholder="请选择">-->
<!--                            <el-option-->
<!--                                    v-for="item in options1"-->
<!--                                    :key="item.i_setup"-->
<!--                                    :label="item.vc_setup"-->
<!--                                    :value="item.i_setup">-->
<!--                            </el-option>-->
<!--                        </el-select>-->
                    </template>
                </el-table-column>
                <el-table-column property="dt_createtime" label="录入时间">
                </el-table-column>
            </el-table>
        </div>
        <!--        分页器-->
        <div class="block">
            <div class="pages">
                <div class="choosepage flexother mrt20 fl">
                    <el-pagination
                            small
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="this.pageNum"
                            :page-sizes="[10, 20, 30, 40]"
                            :page-size="pageSize"
                            layout="total,sizes"
                            :total="totalNum"
                    >
                    </el-pagination>
                    <el-pagination
                            small
                            :pager-count="5"
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="pageNum"
                            :page-size="pageSize"
                            layout="prev, pager, next, jumper"
                            :total="totalNum">
                    </el-pagination>
                </div>
            </div>
        </div>
<!--        <div class="fenye" >-->
<!--            <div class=" choosepage flexother mrt20 fl">-->
<!--                <el-pagination style="position: absolute;right: 0px;"-->
<!--                               @size-change="handleSizeChange"-->
<!--                               @current-change="handleCurrentChange"-->
<!--                               :current-page="pageNum"-->
<!--                               :page-size="pageSize"-->
<!--                               small-->
<!--                               :pager-count="5"-->
<!--                               layout="total, prev, pager, next, jumper"-->
<!--                               :total="totalNum">-->
<!--                </el-pagination>-->
<!--            </div>-->
<!--        </div>-->
    </div>
</template>

<script>
    import * as API from "./api";
    import {mapActions} from "vuex";
    import {baseerp} from "@/utils/baseUrl";

    export default {
        name: "JiaQin",
        props:{
            formvalue:{
                type:Object,
                required:true,
            }
        },
        data() {
            return {
                baseerp:'',
                i_kqtcid:0,
                disabled: false,//编辑按钮操作，进行全文编辑
                isEdit: true,
                dialogVisible: false,
                tableData: [],
                tableDataCopy: [],
                pageNum: 1,//当前所在页
                pageSize: 10,//每页条数
                totalNum: 20,//总条数
                tableHeight:0,
                isSave: false,//新增按钮操作对新增的一条进行可编辑操作
                options: [{
                    i_flag: 0,
                    vc_flag: '补贴'
                }, {
                    i_flag: -1,
                    vc_flag: '加班-补贴'
                }, {
                    i_flag: 1,
                    vc_flag: '不补贴'
                }],
                optionstwo: [],
                options1ttt: { //是否补贴
                    '0': "补贴",
                    '1': "不补贴",
                    '-1': "加班－补贴",
                },
                options1tttwo: { //假勤
                    '1': "请假",
                    '3': "外勤",
                    '2': "加班",
                    '4': "补卡",
                    '5': "缺卡",
                },
                options1: [{ //是否启用
                    i_setup:1,
                    vc_setup: '是'
                }, {
                    i_setup: -1,
                    vc_setup: '否'
                }],
                i_hasrelaxdayoptions: [{ //是否启用
                    i_setup:1,
                    vc_setup: '是'
                }, {
                    i_setup: 0,
                    vc_setup: '否'
                }],
                i_edit_typeList:[

                ],
                i_showtypeList:[
                    {i_id:1,vc_name:"显示假别"},
                    {i_id:2,vc_name:"显示原班次"},
                    {i_id:3,vc_name:"半天假别小时原班"},
                ],
                i_showtypeListTxt:{},
                i_edit_typeListTxt: { //是否补贴
                    '0': "按天请假",
                    '1': "按小时请假",
                },
                date: '',
            }
        },
        watch:{
            '$root.workSize':{
                handler(n,o) {
                    // console.log(n,12312312)
                    this.onResize(n);
                },
                deep:true,
            },
            formvalue:{
                handler(){
                    if (this.formvalue){
                        // console.log(this.formvalue,11);
                        this.i_kqtcid=this.formvalue.i_id;
                        // console.log(this.i_kqtcid)
                        this.search()
                        //this.formData.i_id=this.formvalue.i_id;
                        // this.formData.vc_tcname=this.formvalue.vc_tcname;
                        // this.formData.vc_djmark=this.formvalue.vc_djmark;
                        // this.formData.i_start=this.formvalue.i_start;
                        // this.formData.i_end=this.formvalue.i_end;
                        // this.formData.vc_lruname=this.formvalue.vc_createuser;
                        // this.formData.date=this.formvalue.dt_createtime;
                    }
                },
                immediate:true,
                deep:true
            },



        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.i_showtypeListTxt=this.AtoO(this.i_showtypeList)
            this.baseerp=baseerp
            this.search();
            this.getDateYYYYMMddHHMMSS();
            this.$nextTick(function () {
                this.onResize();

            });
            this.jbType()
            this.jbEditType()
        },
        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h-120);
                $("#homeBox").width(n.w-200);
                // $("#eltable").width(n.w-260);

                this.tableHeight= n.h-155
                // eltable
                // console.log(n.h-500)
                // $('.contentRight').width($("#homeBox").width() - $('.contentLeft').width() - 5 );
                // this.$refs.spread_Edit.onResize();
            },
            ...mapActions(["getCurrentMenuId"]),
            AtoO(arr){
                return arr.reduce((res,item)=>(res[item.i_id]=item.vc_name,res),{})
            },
            heightAuto() {
                this.tableHeight = window.innerHeight -  document.getElementById('body').getBoundingClientRect().top -300;
            },
            deepClone1(obj) {  //判断拷贝的要进行深拷贝的是数组还是对象，是数组的话进行数组拷贝，对象的话进行对象拷贝
                let objClone = Array.isArray(obj) ? [] : {};
                //进行深拷贝的不能为空，并且是对象或者是
                if (obj && typeof obj === "object") {
                    for (let key in obj) {
                        if (obj.hasOwnProperty(key)) {
                            if (obj[key] && typeof obj[key] === "object") {
                                objClone[key] = this.deepClone1(obj[key]);
                            } else {
                                objClone[key] = obj[key];
                            }
                        }
                    }
                }
                return objClone;
            },
            async jbType(){
                let param = {

                };
                let res = await API.jbType(param);
                if (res.code == 1) {
                    this.optionstwo=res.data
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            async jbEditType(){
                let param = {

                };
                let res = await API.jbEditType(param);
                if (res.code == 1) {
                    this.i_edit_typeList=res.data
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            //查询接口
            async search() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                // console.log(this.i_kqtcid)
                let params = {
                    page_size: this.pageNum,
                    page_count: this.pageSize,
                    i_kqtcid:this.i_kqtcid,
                }
                let res = await API.search(params);
                if (res.code == 1) {
                    this.tableData = res.data;
                    this.totalNum = res.count;
                    this.tableDataCopy = this.deepClone1(this.tableData);
                    // console.log(res)
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            //保存接口
            async save(data) {
                // return
                for (const item of data) {
                    let params = {
                        i_id: item.i_id !== 0 ? item.i_id : 0,
                        vc_name: item.vc_name,
                        vc_note: item.vc_note,//标识
                        i_flag: item.i_flag,//是否补贴
                        i_type: item.i_type,//是否补贴
                        i_edit_type:item.i_edit_type,
                        i_order: item.i_order,//是否顺序
                        i_setup: item.i_setup,//是否启用
                        i_hasrelaxday:item.i_hasrelaxday,//是否包含节假日
                        i_showtype:item.i_showtype,//报表显示,
                        dt_createtime: this.date,
                        vc_lrunname: sessionStorage.getItem('lrunname'),
                        i_kqtcid:this.i_kqtcid,
                        i_range:item.i_range
                    }
                    let res = await API.save(params);
                    if (res.code == 1) {
                        this.search();
                        this.disabled = false;//切换按钮状态
                        this.isEdit = this.isSave = true;
                    } else if (res.code == -2) {
                        this.$router.push('/login');
                        this.$message.error(res.message);
                        this.disabled = false;//切换按钮状态
                        this.isEdit = this.isSave = true;
                        this.search();
                    } else {
                        this.search();
                        this.disabled = false;//切换按钮状态
                        this.isEdit = this.isSave = true;
                        this.$message.error(res.message);
                    }
                }
            },
            // setSellStyle({ row, column, rowIndex, columnIndex }) {
            //     if (column.label === '名称') {
            //         return "background:#ffffff;border: 6px solid #e8e8e8;borderRadius: 13px 0 0 5px;"
            //     }
            //     if (columnIndex === 7) {
            //         return "background:#ffffff;border: 6px solid #e8e8e8;borderRadius: 0 13px 5px 0"
            //     } else {
            //         return "background:#ffffff;border: 6px solid #e8e8e8;borderRadius: 13px"
            //     }
            // },

            getDateYYYYMMddHHMMSS() {
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                //return `${date.getFullYear()}-${month}-${strDate}`;
                this.date = `${date.getFullYear()}-${month}-${strDate}`;
            },
            handleSizeChange(pageSize) {
                this.pageSize = pageSize;
                this.isEdit = this.isSave = true;
                this.pageNum = 1
                this.search();
            },
            handleCurrentChange(pageNum) {
                this.isEdit = this.isSave = true;
                this.pageNum = pageNum;
                this.search();
            },
            //新增按钮事件add,newline为新增
            add() {
                const newLine = {
                    i_id: 0,
                    vc_name: '',//名称
                    vc_note: '',//标识
                    i_flag: 0,//是否补贴
                    i_type: this.optionstwo[0].i_id, //假别
                    i_order: '',//是否顺序
                    i_setup: 1,//是否启用
                    i_range:0,
                    i_edit_type:this.i_edit_typeList[0].i_id,
                    dt_createtime: this.date,
                }
                this.tableData.unshift(newLine);
                this.isEdit = this.isSave = false;
            },
            //编辑切换按钮状态
            edit() {
                this.disabled = !this.disabled;
            },
            recursion(data, data1,index) {
                for (let i in data) {
                    if (typeof data[i] === 'object' && data[i] !== null) {
                        return this.recursion(data[i], data1[i])
                    } else {
                        if (data[i] !== data1[i]) {
                            return true
                        }
                    }
                }
            },
            editSave() {  //非空判断保存和编辑
                if (this.isEdit) {
                    let data = this.tableData.filter((data, i) => {
                        return this.recursion(data, this.tableDataCopy[i]) || false
                    });
                    //编辑时
                    for (let i of data) {
                        if (i.vc_name === '') {
                            this.$message({
                                type: "error",
                                message: "名称不能为空！",
                            })
                            return
                        }
                        if (i.vc_note === '') {
                            this.$message({
                                type: "error",
                                message: "标注不能为空！",
                            })
                            return
                        }
                        if (i.i_flag === '') {
                            this.$message({
                                type: "error",
                                message: "是否补贴不能为空！",
                            })
                            return
                        }
                        if (i.i_type === '') {
                            this.$message({
                                type: "error",
                                message: "假别不能为空！",
                            })
                            return
                        }
                        if (i.i_order === '') {
                            this.$message({
                                type: "error",
                                message: "显示顺序不能为空！",
                            })
                            return
                        }
                        if (i.i_setup === '') {
                            this.$message({
                                type: "error",
                                message: "是否启用不能为空！",
                            })
                            return
                        }
                        if (i.i_range === '') {
                            this.$message({
                                type: "error",
                                message: "约束时间不能为空！",
                            })
                            return
                        }
                    }
                    this.save(data)
                } else {
                    //保存时
                    let data = []
                    for (let i of this.tableData) {
                   if (i.i_id === 0) {
                       if (i.vc_name === '') {
                           this.$message({
                               type: "error",
                               message: "名称不能为空！",
                           })
                           return
                       }
                       if (i.vc_note === '') {
                           this.$message({
                               type: "error",
                               message: "标注不能为空！",
                           })
                           return
                       }
                       if (i.i_flag === '') {
                           this.$message({
                               type: "error",
                               message: "是否补贴不能为空！",
                           })
                           return
                       }
                       if (i.i_type === '') {
                           this.$message({
                               type: "error",
                               message: "假别不能为空！",
                           })
                           return
                       }
                       if (i.i_order === '') {
                           this.$message({
                               type: "error",
                               message: "显示顺序不能为空！",
                           })
                           return
                       }
                       if (i.i_setup === '') {
                           this.$message({
                               type: "error",
                               message: "是否启用不能为空！",
                           })
                           return
                       }
                       if (i.i_range === '') {
                           this.$message({
                               type: "error",
                               message: "约束时间不能为空！",
                           })
                           return
                       }
                            data.push(i)
                        }
                    }
                    this.save(data)
                }


            },
        },
        //销毁
        beforeDestroy() {
            window.removeEventListener('resize', this.heightAuto)
        },
    }
</script>

<style  lang="scss" scoped>
    .jqTitle {
        height: 40px;
        position: relative;
    }

    .jqTitle > div {
        display: inline-block;
        position: absolute;
        /*left: 20px;*/
        top: 10px;
    }
    /*.jqBody{*/
    /*    overflow-y: scroll;*/
    /*}*/


    /*.fenye>span{*/
    /*    position:absolute ;*/
    /*    right:350px;*/
    /*    display: inline-block;*/
    /*    margin-top: 25px;*/

    /*}*/
    /deep/{

        .el-button--mini, .el-button--mini.is-round{
            /*height: 54px;*/
            /*width: 26px;*/
        }
        .el-tabs--top .el-tabs__content{
            height: 90% !important;

            overflow: visible !important;
            /*height:calc(100% - 5px) !important;*/
        }
        .fenye {
            height: 50px !important;
        }
    }

    .pages{
        height: 50px;
    }
    .fl {
        float: left;

    .el-button--primary {
        color: #efd773;
        background-color: white;
        border: 0;
        text-align: center;
        padding: 0;
        height: 28px;
        width: 46px;
        margin: 12px 0 0 10px;
    }

    }
    .flexother {
        display: flex;
        /*flex-flow: wrap;*/
        justify-content: space-between;
        align-items: center;
    }

    .mrt20 {
        margin-top: 20px;
    }

    .choosepage {
        width: 90%
    }
/deep/{
    /*.el-button--success.is-disabled, .el-button--success.is-disabled:active, .el-button--success.is-disabled:focus, .el-button--success.is-disabled:hover{*/
    /*    background-color:rgb(206,205,200) ;*/
    /*}*/
    /*.el-button--success{*/
    /*    background-color: rgb(72,182,87);*/
    /*}*/
}
</style>